import {combineReducers} from "redux";
import ApplicationConst from "../ApplicationConst";

const language = (state={active: "de", map:null}, action=null) => {
  switch(action.type){
    case ApplicationConst.SWITCH_LANGUAGE:
      return Object.assign({}, state, {active: action.payload.language});
    case ApplicationConst.GET_LANGUAGE_PACKAGE:
      return Object.assign({}, state, {map:action.payload});
    default:
      return state;
  }
};

const location = (state={token:null}, action=null) => {
  switch(action.type){
    case "LOCATION":
      return Object.assign({},state, {token: action.payload.token});
    default:
      return state;
  }
};

const token = (state={token:null}, action=null) => {
  switch(action.type){
    case ApplicationConst.SET_TOKEN:
      return Object.assign({},state, {token: action.payload.token});
    default:
      return state;
  }
};

const application = combineReducers({language, location, token});
export { application };



// WEBPACK FOOTER //
// ./src/reducer/AppReducer.js